export const CMP_CDID = "76286";
export const CMP_HEALTH_TIMEOUT_MS = 5_000;
